import React from 'react';
import sinaloaMapDefault from "../../../Styles/imagenes/sinaloa-map-green2.png";

// ─── Colores de estado ─────────────────────────────────────────────────────────
const GREEN    = "#27762F";
const YELLOW   = "#a98000";
const CRITICAL = "#bd413f";
const BLUE     = "#3275b4";

function statusOf(pct) {
    if (pct >= 100) return { label: "Excedente", color: BLUE     };
    if (pct >= 60)  return { label: "Óptimo",    color: GREEN    };
    if (pct >= 30)  return { label: "Moderado",  color: YELLOW   };
    return               { label: "Crítico",    color: CRITICAL };
}

// ─── Posición de cada pin en el mapa (158×184 px) ─────────────────────────────
const PIN_POSITIONS = [
    { key: "luisdonaldo",     top: 12,  left: 44  },
    { key: "miguelhidalgo", top: 32,  left: 23  },
    { key: "josefaortiz",        top: 54,  left: 1   },
    { key: "guillermoblake",  top: 65,  left: 34  },
    { key: "gustadodiaz",     top: 67,  left: 62  },
    { key: "eustaquiobuelna",   top: 93,  left: 60  },
    { key: "adolfolopez",         top: 98,  left: 89  },
    { key: "sanalona",      top: 126, left: 85  },
    { key: "juanguerra",     top: 127, left: 104 },
    { key: "joselopez",     top: 149, left: 102 },
    { key: "aurelio",       top: 175, left: 125 },
];

const PresasSinaloaNuevoDiseno = ({
    presas,
    mapSrc = sinaloaMapDefault,
    presaSeleccionada,
    presaHovered,
    onPresaSelect,
    onPresaHover,
}) => {
    if (!presas) return null;

    // Pines con color dinámico
    const pins = PIN_POSITIONS.map(({ key, top, left }) => {
        const presa = presas[key];
        const pct   = presa?.porcentaje ?? 0;
        const { color } = statusOf(pct);
        return { key, top, left, color };
    });

    // Leyenda ordenada de mayor a menor porcentaje
    const leyenda = PIN_POSITIONS
        .map(({ key }) => {
            const presa = presas[key];
            const pct   = presa?.porcentaje ?? 0;
            const { color } = statusOf(pct);
            return {
                key,
                name:  presa?.presa || key,
                pct:   parseFloat(pct).toFixed(1).replace(/\.0$/, ""),
                color,
            };
        })
        .sort((a, b) => parseFloat(b.pct) - parseFloat(a.pct));

    return (
        <div className="presas-body">
            {/* Mapa con pines interactivos */}
            <div className="presas-map-container">
                <img src={mapSrc} alt="Mapa de Sinaloa" className="presas-map-image" />
                {pins.map((p) => (
                    <div
                        key={p.key}
                        className={[
                            'presas-pin',
                            presaHovered     === p.key ? 'presas-pin--hovered'  : '',
                            presaSeleccionada === p.key ? 'presas-pin--selected' : '',
                        ].filter(Boolean).join(' ')}
                        style={{ top: p.top, left: p.left, background: p.color }}
                        onClick={() => onPresaSelect?.(p.key)}
                        onMouseEnter={() => onPresaHover?.(p.key)}
                        onMouseLeave={() => onPresaHover?.(null)}
                    />
                ))}
            </div>

            {/* Leyenda interactiva */}
            <div className="presas-legend">
                {leyenda.map((d) => (
                    <div
                        key={d.key}
                        className={[
                            'presas-legend-row',
                            presaHovered     === d.key ? 'presas-legend-row--hovered'  : '',
                            presaSeleccionada === d.key ? 'presas-legend-row--selected' : '',
                        ].filter(Boolean).join(' ')}
                        onClick={() => onPresaSelect?.(d.key)}
                        onMouseEnter={() => onPresaHover?.(d.key)}
                        onMouseLeave={() => onPresaHover?.(null)}
                    >
                        <span className="presas-legend-dot" style={{ background: d.color }} />
                        <span className="presas-legend-name">{d.name}</span>
                        <span className="presas-legend-pct" style={{ color: d.color }}>{d.pct}%</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PresasSinaloaNuevoDiseno;
